import React from 'react'
import {   Field} from 'redux-form'
import {SVNumber,SVNArray, SVStringEp, SVDate,  SVInputEp} from '../core'



const svinput = ({input, label, type, meta:{error, touched}})=>{
    return(

     
            <input {...input}  component="input" type="input" placeholder="clubName"  className="form-control" />
           

    
       
    )

}
 export class SVPortComponentEp extends React.Component{
    

    constructor(props){
        super(props)
        this.svDDChange = this.svDDChange.bind(this)
        this.svfieldType=  this.props.portType || 'CL_String'
        this.state={
            svfieldType: this.props.portType || 'CL_String'
        }
        this.getCoreComponent = this.getCoreComponent.bind(this)


    }
    componentWillReceiveProps(next){
        console.log(next)

    }

    getCoreComponent(fieldType, member, index, placeholderString){
        console.log('sv--fieldType^^^^^^^^^^^^^^^^^^^^^^^^^^^^')
        console.log(fieldType)
        let svview  =  (<SVStringEp svfieldType={fieldType}   member={member} index={index} placeholder={placeholderString}> </SVStringEp>) 
        switch(fieldType){
            case 'CL_String':
            svview  =  (<SVStringEp svfieldType={fieldType}   member={member} index={index} placeholder={placeholderString}> </SVStringEp>) 
           // svview = 
            break
            case 'CL_Number':
            svview = (  <SVNumber svfieldType={fieldType}  member={member} index={index} placeholder="Port X" > </SVNumber>)
            break
            case 'CL_Date':
            svview = ( <SVDate svfieldType={fieldType}  portId={`${member}.portInput`} > </SVDate>)
            break
            case 'CL_NArray':
            svview  =  (<SVNArray svfieldType={fieldType}   member={member} index={index} placeholder="21,34,35"> </SVNArray>) 
            break

        }

        return svview
        
    }
    svDDChange(e){
        //this.refs.DropdownList.refs
        //this.refs.DropdownList.refs.inner.handleClick()
        console.log(e)

        //ob.target.value
        if(e.target.value =='string'){
            console.log('sv change action to change class')
           // this.props.initialValues.gene
            this.svfieldType= 'CL_String'
        }else if(e.target.value == 'date'){
            this.svfieldType= 'CL_Date'
        }else if(e.target.value == 'narray'){
            this.svfieldType= 'CL_NArray'    

        }else{
            this.svfieldType= 'CL_Number'
        }

        this.setState({
            svfieldType:this.svfieldType
        })

    }

    render(){
        let me = this
        //  this.props.initialValues.svfieldType= 'CL_String'
        console.log(this.props)
        const {member, index, portTypes, locationTypes, inputSchemaTypes}= this.props
       // const  {svshow,  svhide, portId, portName, portTypes, locationId, locationText,locationTypes,  children} = this.props
       // const portEntryId="sv"+portId
        const svfieldType = this.state.svfieldType
       

      
        return ( 
        <div className="box-block">  
         <div className="form-group">
              <label className="svform-label" htmlFor="`${member}.portName`" > Port Name</label>
              <SVInputEp member={member} index={index} placeholder="Port X" /> 
             {/*   
               <SVInput  name={`${member}.portName`} placeholder="Port X" /> 
              <Field
                    name={`${member}.portName`}
                    type="text"
                    component={renderField}

                    className="form-control"
                   
                  />
                  */}
        </div>   
{/* 
        <div className="form-group">
                <label htmlFor={`${member}.portType`}  > Port Type</label>
                <Field  component="select" id={`${member}.portType`}   name={`${member}.portType`} className="form-control" >
                
                    <option value="">Select {`${member}.portType`}  </option>
                    {
        
                
                portTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                    
                    
                    
                   
                )}
        
                </Field>
        </div>         

 
        <div className="form-group">
               


                <label className="svform-label" htmlFor={`${member}.portType`} > Port Type</label>

                <DropdownList
                  ref="DropdownList"
                  id={`${member}.portType`} name={`${member}.portType`} 
                  onChange={me.svDDChange}
                 data={portTypes} 
                valueField="key"
                textField="value"
                 className="form-control" >
                
                  
        
                </DropdownList>
             </div>   
  */}  
             <div className="form-group">
                <label htmlFor={`${member}.portType`}  > Port Types</label>
                <Field   onChange={me.svDDChange}  component="select" id={`${member}.portType`}   name={`${member}.portType`} className="form-control" >
                
                    <option value="">Select {`${member}.portType`}  </option>
                    {
        
                
        portTypes.map(  (o, idx)=>(  <option value={o.value} key={o.key}>{o.key}</option>)
                    
                    
                    
                   
                )}
        
                </Field>
        </div>

           

                <div className="form-group">
                  <label className="svform-label"  htmlFor="`${member}.portInput`" > Port Input</label>
                 
                 {this.getCoreComponent( svfieldType, member, index, 'svdef')} 
                 {/*
                  <SVNumber  portId={`${member}.portInput`} > </SVNumber>

            */}
            
                  {/*svfieldType == 'CL_String' ?   (<SVStringEp svfieldType={this.svfieldType}   member={member} index={index} placeholder="XMat"> </SVStringEp>) :   svfieldType == 'CL_Number'?(  <SVNumber  member={member} index={index} placeholder="Port X" > </SVNumber>) : ( <SVDate svfieldType={this.svfieldType}  portId={`${member}.portInput`} > </SVDate>) */}
                </div>

               
                
        {/*   
         {svfieldType == 'CL_String' ?   (<SVString svfieldType={this.svfieldType} {...this.props} > </SVString>) :   svfieldType == 'CL_Number'?( <SVNumber svfieldType={this.svfieldType} {...this.props} > </SVNumber>) : ( <SVDate svfieldType={this.svfieldType} {...this.props} > </SVDate>) }
               
              

                <Field  component={SVNumber}  label="Task Name" label_forName="name"  type="text"  ref="_taskName" name="name" id="name"    className="form-control" placeholder="SVparalleltask" />
                
                <Field  type="text" placeholder="2" component="input" name={portEntryId } id={portEntryId} placeholder={portEntryId} >
        
                 </Field> 

                 <SVNumber {...this.props} > </SVNumber>
                 */}

        <div className="form-group">
                <label htmlFor={`${member}.locationId`}  > Location</label>
                <Field  component="select" id={`${member}.locationId`}   name={`${member}.locationId`} className="form-control" >
                
                    <option value="">Select {`${member}.locationId`}  </option>
                    {
        
                
                locationTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                    
                    
                    
                   
                )}
        
                </Field>
        </div>


        <div className="form-group">
                <label htmlFor={`${member}.inputSchemaType`}  > Input Schema Type(Port)</label>
                <Field  component="select" id={`${member}.inputSchemaType`}   name={`${member}.inputSchemaType`} className="form-control" >
                
                    <option value="">Select Input Schema Type for (Port)  </option>
                    {
        
                
        inputSchemaTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                    
                    
                    
                   
                )}
        
                </Field>
        </div>



        
               
    
        
        
       
        </div>     )


    }
}

